<p-toast></p-toast>

<p-galleria [value]="infoItems"
            [(visible)]="displayImg"
            [(activeIndex)]="activeImgIndex"
            [responsiveOptions]="imageOptions"
            [containerStyle]="{'max-width': '50%'}"
            [circular]="true" [fullScreen]="true" [showItemNavigators]="true">
    <ng-template pTemplate="item" let-item>
            <img [src]="item.value" class="galleria-image" />
    </ng-template>

    <ng-template pTemplate="thumbnail" let-item>
        <ng-container *ngIf="item.thumbnail">
            <div class="grid grid-nogutter justify-content-center">
                <img [src]="item.value" class="h-80" />
            </div>
        </ng-container>
        <div [ngClass]="{'hiddenBlack': activeImgIndex !== item.ind}" class="galleria-title-font h-35 mt-2">{{item.title}}</div>
        <div [ngClass]="{'hiddenBlack': activeImgIndex !== item.ind}" class="galleria-subtitle-font h-20">{{item.subTitle}}</div>
    </ng-template>
</p-galleria>

<customer-info *ngIf="isVisibleCustomerInfo"
               [isVisibleCustomerInfo]="isVisibleCustomerInfo"
               [_customerId]="customerId"
               (changedVisibleCustomerInfoEmit)="changedVisibleCustomerInfoEmit($event)"></customer-info>

<driver-detail [_visibleDetail]="visibleDriverDetail"
               [_driverId]="riderOrderDetail.RiderId"
               (changedVisibleDetailEmit)="changedVisibleDriverDetailEmit($event)"
               *ngIf="visibleDriverDetail"></driver-detail>

<live-map-assign-rider *ngIf="showAssingRiderPopup"
                       [orderFromList]="riderOrderDetail"
                       (assignRider)="onRiderAssign()"
                       (hide)="onAssingRiderPopupHide()"></live-map-assign-rider>

<p-sidebar [(visible)]="isVisibleDisplayOrderDetail"
           [position]="'right'"
           (onHide)="cancel()"
           [style]="{width: selectedOrder.StatusId !== xpressDeliveryStatus.Canceled ? '1050px' : '800px', height: '100%'}">

    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;" *ngIf="riderId > 0">
            <a style="opacity: 0.5; color: #333333; letter-spacing: -0.43px; font: normal normal bold 18px/12px Montserrat; ">Ride ID: </a>
            <a style="opacity: 1; color: #333333; font: normal normal bold 18px/12px Montserrat; ">{{riderId}}</a>
        </div>
        <div *ngIf="riderId <= 0">
            Order
        </div>
    </ng-template>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 120px)'}"
                   [styleClass]="'app-scrollpanel'">
        <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

        <!-- Returning to the Details tab refetches the order; keeping the loaded content on screen avoids a flicker. -->
        <div *ngIf="isOrderDetailSpinner && !riderOrderDetail" class="booking-detail-loading">
            <spinner></spinner>
        </div>

            <div *ngIf="riderOrderDetail">
                <div *ngIf="activeTab === menuTab.BookingDetail" class="orderdetail-block">
                    <p-scrollPanel [style]="{width:'100%', height: 'calc(96vh - 240px)'}"
                                   [styleClass]="'app-scrollpanel'">

                        <div *ngIf="!this.appDataService.isBoracayLocation">
                            <div class="flex flex-row">
                                <div class="ml-3" style="max-width: 75%;">
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Booking ID:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.XpressDeliveryOrderId}}</div>
                                        <img class="copy-icon" alt="Copy" (click)="copyTextToClipboard(riderOrderDetail.XpressDeliveryOrderId)" src="/Content/xpress-app/images/svg/copy-icon.svg" />
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Service:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.isScanAndRide ? '[Scan and Ride]' : ''}} {{riderOrderDetail.ServiceText}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block" *ngIf="appDataService.isDumagueteLocation">
                                        <div class="lm-active-order-details-field-name">Pax Count:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.SinglePaxCount}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block" *ngIf="appDataService.isDumagueteLocation">
                                        <div class="lm-active-order-details-field-name">Luggage Count:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.LuggageCount}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block" *ngIf="riderOrderDetail.BookingLabel">
                                        <div class="lm-active-order-details-field-name">Booking Label:</div>
                                        <div class="ui-resizable-column" style="margin-left: auto">
                                            <span *ngIf="riderOrderDetail.BookingLabel === 'B2B'"
                                                  style="background-color: #004060; color: #FFFFFF;"
                                                  class="ui-resizable-column onbg-status-col">
                                                {{OrderUtils.getBookingLabelDisplayText(riderOrderDetail.BookingLabel)}}
                                            </span>
                                            <span *ngIf="riderOrderDetail.BookingLabel === 'Primary'"
                                                  style="background-color: #A1BDCA; color: #004060;"
                                                  class="ui-resizable-column onbg-status-col">
                                                {{riderOrderDetail.BookingLabel}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Status:</div>
                                        <div class="ui-resizable-column" style="margin-left: auto">
                                            <span [ngStyle]="OrderUtils.getActiveOrderStatusStyles(riderOrderDetail.LocalStatusText)"
                                                  class="ui-resizable-column onbg-status-col">
                                                {{OrderUtils.getStatusDisplayText(riderOrderDetail.StatusText)}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="lm-active-order-details-field-block" *ngIf="riderOrderDetail.CompleteReason || riderOrderDetail.CancelReason">
                                        <div class="lm-active-order-details-field-name">Reason:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.CompleteReason || riderOrderDetail.CancelReason}}</div>
                                    </div>
                                <div class="lm-active-order-details-field-block" *ngIf="riderOrderDetail.AdminActionTimestamp">
                                    <div class="lm-active-order-details-field-name">Admin Action<br/>Timestamp:</div>
                                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.AdminActionTimestamp | date:'MMM dd, yyyy h:mm a'}}</div>
                                </div>
                                <div class="lm-active-order-details-field-block" *ngIf="riderOrderDetail.AdminActionedBy">
                                    <div class="lm-active-order-details-field-name">Actioned By:</div>
                                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.AdminActionedBy}}</div>
                                </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Driver:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.RiderFullName}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block" style="margin-bottom: 25px;">
                                        <div class="lm-active-order-details-field-name">Pickup:</div>
                                        <div class="lm-active-order-details-field-value" style="max-width: 230px; text-align:justify">
                                            <div class="font-bold">{{ riderOrderDetail.PickupAddress?.BuildingName || '(No Place Name)' }}</div>
                                            <div>{{riderOrderDetail.PickupAddress?.Address}}</div>
                                        </div>
                                    </div>
                                    <ng-container *ngFor="let dropoff of riderOrderDetail.DropoffOrderPoints; let i = index;">
                                        <div class="lm-active-order-details-field-block" style="margin-bottom: 25px;">
                                            <div class="lm-active-order-details-field-name">Drop:</div>
                                            <div class="lm-active-order-details-field-value" style="max-width: 230px; text-align: justify">
                                                <div class="font-bold">{{ dropoff.BuildingName || '(No Place Name)' }}</div>
                                                <div>{{dropoff.Address}}</div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Elapsed Time:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.SessionTime}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Duration:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.Duration}}</div>
                                    </div>
                                </div>
                                <div>
                                    <div *ngIf="pricingBreakdown && pricingBreakdown.Lines && pricingBreakdown.Lines.length">
                                        <div class="lm-active-order-details-field-block lm-active-order-details-field-block--amount"
                                             *ngFor="let line of pricingBreakdown.Lines">
                                            <div class="lm-active-order-details-field-name"
                                                 [ngStyle]="{ color: isBreakdownDeduction(line) ? '#dc3545' : '', 'font-weight': isBreakdownTotal(line) ? '600' : '' }">{{ line.DisplayName }}:</div>
                                            <div class="lm-active-order-details-field-value"
                                                 [ngStyle]="{ color: isBreakdownDeduction(line) ? '#dc3545' : '', 'font-weight': isBreakdownTotal(line) ? '600' : '' }">{{ formatBreakdownAmount(line) }}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="pricingBreakdownLoading" class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-value">Loading pricing…</div>
                                    </div>
                                    <div *ngIf="!pricingBreakdownLoading && pricingBreakdownFailed" class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-value">
                                            Failed to load pricing.
                                            <a class="cursor-pointer" style="color: #004060; text-decoration: underline;" (click)="retryPricingBreakdown()">Retry</a>
                                        </div>
                                    </div>
                                </div>

                                <booking-receipt [customer]="customerReceipt" [driver]="driverReceipt"></booking-receipt>
                            </div>
                        </div>
                        <div *ngIf="this.appDataService.isBoracayLocation">
                            <div class="flex flex-row">
                                <div class="ml-3" style="max-width: 75%;">
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Booking ID:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.XpressDeliveryOrderId}}</div>
                                        <img class="copy-icon" alt="Copy" (click)="copyTextToClipboard(riderOrderDetail.XpressDeliveryOrderId)" src="/Content/xpress-app/images/svg/copy-icon.svg" />
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Service:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.ServiceText}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Status:</div>
                                        <div class="ui-resizable-column" style="margin-left: auto">
                                            <span [ngStyle]="OrderUtils.getActiveOrderStatusStyles(riderOrderDetail.LocalStatusText)"
                                                  class="ui-resizable-column onbg-status-col">
                                                {{OrderUtils.getStatusDisplayText(riderOrderDetail.StatusText)}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Driver:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.RiderFullName}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block" style="margin-bottom: 25px;">
                                        <div class="lm-active-order-details-field-name">Pickup:</div>
                                        <div class="lm-active-order-details-field-value" style="max-width: 230px; text-align:justify">
                                            <div class="font-bold">{{ riderOrderDetail.PickupAddress?.BuildingName || '(No Place Name)' }}</div>
                                            <div>{{riderOrderDetail.PickupAddress.Address}}</div>
                                        </div>
                                    </div>
                                    <ng-container *ngFor="let dropoff of riderOrderDetail.DropoffOrderPoints; let i = index;">
                                        <div class="lm-active-order-details-field-block" style="margin-bottom: 25px;">
                                            <div class="lm-active-order-details-field-name">Drop:</div>
                                            <div class="lm-active-order-details-field-value" style="max-width: 230px; text-align:justify">
                                                <div class="font-bold">{{ dropoff.BuildingName || '(No Place Name)' }}</div>
                                                <div>{{dropoff.Address}}</div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Elapsed Time:</div>
                                        <div class="lm-active-order-details-field-value">
                                            {{riderOrderDetail.SessionTime}}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div *ngIf="pricingBreakdown && pricingBreakdown.Lines && pricingBreakdown.Lines.length">
                                        <div class="lm-active-order-details-field-block lm-active-order-details-field-block--amount"
                                             *ngFor="let line of pricingBreakdown.Lines">
                                            <div class="lm-active-order-details-field-name"
                                                 [ngStyle]="{ color: isBreakdownDeduction(line) ? '#dc3545' : '', 'font-weight': isBreakdownTotal(line) ? '600' : '' }">{{ line.DisplayName }}:</div>
                                            <div class="lm-active-order-details-field-value"
                                                 [ngStyle]="{ color: isBreakdownDeduction(line) ? '#dc3545' : '', 'font-weight': isBreakdownTotal(line) ? '600' : '' }">{{ formatBreakdownAmount(line) }}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="pricingBreakdownLoading" class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-value">Loading pricing…</div>
                                    </div>
                                    <div *ngIf="!pricingBreakdownLoading && pricingBreakdownFailed" class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-value">
                                            Failed to load pricing.
                                            <a class="cursor-pointer" style="color: #004060; text-decoration: underline;" (click)="retryPricingBreakdown()">Retry</a>
                                        </div>
                                    </div>
                                </div>

                                <booking-receipt [customer]="customerReceipt" [driver]="driverReceipt"></booking-receipt>
                            </div>
                        </div>
                        <hr class="lm-active-order-details-hr" />
                        <div id="map" class="live-map-map" style="width: calc(100%); height: calc(40%); "></div>
                    </p-scrollPanel>
                    <div class="flex justify-content-end" style="margin-top: 15px;">
                        <div
                        *ngIf="riderOrderDetail.LocalStatusText !== BookingStatus.Requesting && !scheduledBookingConfig.canBeCancelled">
                            <button pButton pRipple type="button" label="Cancel Trip"
                                    (click)="cancelDeliveryOrder()"
                                    class="p-button btn-cancel-trip btn-size"></button>
                        </div>
                        <button *ngIf="scheduledBookingConfig.canBeCancelled" pButton pRipple type="button" label="Cancel Trip" (click)="cancelDeliveryOrder()"
                            class="p-button btn-cancel-trip btn-size border-none" [disabled]="!scheduledBookingConfig.canBeCancelled"></button>
                        <div *ngIf="riderOrderDetail.LocalStatusText !== BookingStatus.Requesting">
                            <button pButton pRipple type="button" label="Complete Trip"
                                    (click)="completeOrder()"
                                    class="p-button btn-confirm btn-size"></button>
                        </div>
                        <div>
                            <button [disabled]="riderOrderDetail.LocalStatusText !== BookingStatus.Requesting" *ngIf="isForceAssignVisible()"
                                    (click)="onAssingRiderClick()"
                                    pButton pRipple type="button" label="Force Assign"
                                    class="btn-force-assign p-button-secondary btn-lift-ban-cancel btn-lift-ban p-button-text btn-cancel btn-size"></button>
                        </div>
                        <div>
                            <button [disabled]="riderOrderDetail.LocalStatusText !== BookingStatus.Requesting"
                                    pButton type="button" label="Prioritize Request"
                                    (click)="onPrioritizeClick()"
                                    class="btn-prioritize-request btn-size"></button>
                        </div>
                    </div>
                    <p-dialog header="Force Assign Request" [(visible)]="isVisibleForceAssignDialog" [modal]="true"
                              [draggable]="false" [resizable]="false" (onHide)="hideForceAssignDialog()">
                        <div class="flex flex-column align-center">
                            <div style="margin-bottom: 21px;margin-top: 23px;">
                                <span class="search-panel-item p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" class="search-input"
                                        style="width: 462px;"
                                        placeholder="Search Paid Driver" />
                                </span>
                            </div>
                            <div class="riders-title">
                                <div class="title-float-left font-medium white-space-nowrap">Nearby Drivers</div>
                            </div>
                            <div *ngFor="let driver of assignDriverItems" style="width: 100%; margin-bottom: 10px;">
                                <div style="width: 100%;" class="flex align-items-center w-full p-2">
                                    <p-avatar class="mr-13px" image="{{driver.imageUrl}}" shape="circle" />
                                    <div class="flex flex-column">
                                        <span class="font-bold white-space-nowrap mb-5px">{{ driver.name }}</span>
                                        <div class="rider-active-status-container">
                                            <span class="rider-active-status">
                                                <div class="rider-active-status-label">
                                                    {{driver.status}}
                                                </div>
                                            </span>
                                            <span>
                                                {{driver.distance}}km away
                                            </span>
                                        </div>

                                    </div>
                                    <div class="ml-auto assign-button-container">
                                        <span class="rider-assign-button">
                                            <div style="color: white">
                                                Assign
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template pTemplate="footer"></ng-template>
                    </p-dialog>
                </div>

            <div *ngIf="activeTab === menuTab.People" class="mt-4">
                <p-accordion>
                    <p-accordionTab [(selected)]="senderSelected">
                        <ng-template pTemplate="header">
                            <span class="flex align-items-center gap-2 w-full assigning-text font-18">
                                <span class="font-bold white-space-nowrap">Sender</span>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="body">
                            <div class="lm-active-order-details-main-block">
                                <div class="flex flex-row" style="justify-content: space-between;">
                                    <div class="left-img-block">
                                        <img class="user-img" *ngIf="riderOrderDetail.UserImageUrl; else placeholder" src="{{riderOrderDetail.UserImageUrl}}" />
                                        <ng-template #placeholder>
                                            <img class="user-img" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                                        </ng-template>

                                        <div class="ml-5" style="margin-top: -45px;">
                                            <div class="lm-left-block">Name:</div>
                                            <div class="lm-left-block">Sign up:</div>
                                            <div class="lm-left-block">Phone:</div>
                                            <div class="lm-left-block">Rating:</div>
                                            <div class="lm-left-block">Account:</div>
                                            <div class="lm-left-block">Application:</div>
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <div class="lm-right-block">
                                            <span class="lm-active-order-link" (click)="handleCustomerInfoClick(riderOrderDetail.UserId)">
                                                {{riderOrderDetail.UserFirstName}} {{riderOrderDetail.UserLastName | slice:0:1}}.
                                            </span>
                                        </div>
                                        <div class="lm-right-block">{{riderOrderDetail.UserCreatedAtText}} ({{riderOrderDetail.UserSignUpDaysPassed}} days)</div>
                                        <div class="flex lm-right-block">
                                            <div class="mt-2 mr-8">{{riderOrderDetail.UserPhoneMask}}&nbsp;</div>
                                            <div class="badge verified" [ngClass]="{'verified': isPhoneNumberVerified}">Verified</div>
                                        </div>
                                        <div class="lm-right-block">
                                            <span class="star-icon">&#9733;</span> {{riderOrderDetail.UserRatingFormatted}}
                                        </div>
                                        <div class="lm-right-block">
                                            <span class="lm-active-order-link">{{(riderOrderDetail.LoginProvider) ? riderOrderDetail.LoginProvider : 'Xpress'}}</span>
                                        </div>
                                        <div class="lm-right-block">
                                            <span class="badge xpress-app">Xpress App</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="lm-active-order-details-main-block mt-3">
                                <ng-container *ngIf="!isCustomerStatisticsLoading; else customerStatisticsSkeleton">
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Bookings:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.BookingsCount}}</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Completed:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.CompletedCount}} ({{riderOrderDetail.CompletedPercent}}%)</div>
                                    </div>
                                    <div class="lm-active-order-details-field-block">
                                        <div class="lm-active-order-details-field-name">Spend:</div>
                                        <div class="lm-active-order-details-field-value">{{riderOrderDetail.TotalSpendText}}</div>
                                    </div>
                                </ng-container>
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Priority:</div>
                                    <div class="lm-active-order-details-field-value badge regular" [ngClass]="{'vip': riderOrderDetail.IsPriority}">{{getPriority()}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </p-accordionTab>

                    <p-accordionTab [(selected)]="recipientSelected">
                        <ng-template pTemplate="header">
                            <span class="flex align-items-center gap-2 w-full assigning-text font-18">
                                <span class="font-bold white-space-nowrap">Recipient</span>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="body">
                            <div class="lm-active-order-details-main-block">
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Name:</div>
                                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.DeliveryRecipientName}}</div>
                                </div>
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Phone:</div>
                                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.DeliveryRecipientPhone}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </p-accordionTab>

                    <p-accordionTab [(selected)]="driverSelected">
                        <ng-template pTemplate="header">
                            <span class="flex align-items-center gap-2 w-full assigning-text font-18">
                                <span class="font-bold white-space-nowrap">Driver</span>
                            </span>
                        </ng-template>
                        <ng-template pTemplate="body">
                            <div class="lm-active-order-details-main-block">
                                <div class="flex flex-row" style="justify-content: space-between;">
                                    <div class="left-img-block">
                                        <img class="user-img" *ngIf="riderOrderDetail.RiderImageUrl; else placeholder" src="{{riderOrderDetail.RiderImageUrl}}" />
                                        <ng-template #placeholder>
                                            <img class="user-img" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                                        </ng-template>

                                        <div class="ml-5" style="margin-top: -45px;">
                                            <div class="lm-left-block">Name:</div>
                                            <div class="lm-left-block">Sex:</div>
                                            <div class="lm-left-block">Phone:</div>
                                            <div class="lm-left-block">Email:</div>
                                            <div class="lm-left-block">Date of Birth:</div>
                                            <div class="lm-left-block">Full Profile:</div>
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <div class="lm-right-block">{{ riderOrderDetail.RiderFullName }}</div>
                                        <div class="lm-right-block">{{ riderOrderDetail.RiderGender || 'N/A' }}</div>
                                        <div class="lm-right-block">{{ riderOrderDetail.RiderPhone || 'N/A' }}</div>
                                        <div class="lm-right-block">{{ riderOrderDetail.RiderEmail || 'N/A' }}</div>
                                        <div class="lm-right-block">{{ riderOrderDetail.RiderBirthDate || 'N/A' }}</div>
                                        <div class="lm-right-block lm-active-order-link" (click)="visibleDriverDetail=true">View</div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-accordionTab>
                </p-accordion>
            </div>

            <div *ngIf="activeTab === menuTab.ItemDetails" class="mt-4">
                <div class="lm-active-order-details-main-block flex mb-3">
                    <div class="flex">
                        <img class="gallery-img package-img" *ngIf="riderOrderDetail.PackagePhotoImageUrl" src="{{riderOrderDetail.PackagePhotoImageUrl}}" (click)="showVisibleImageModal(OrderImageType.Package)" />
                        <div class="ml-4 mt-3">
                            <div class="lm-left-block mt-3">Weight:</div>
                            <div class="lm-left-block">Type of Item:</div>
                        </div>
                    </div>
                    <div class="mt-5" style="margin-left: 110px">
                        <div class="lm-right-block">{{ riderOrderDetail.DeliveryWeight || 'N/A' }}</div>
                        <div class="lm-right-block">{{ riderOrderDetail.DeliveryItemTypeText || 'N/A' }}</div>
                    </div>
                </div>

                <div class="lm-active-order-details-main-block flex mb-3">
                    <div class="flex">
                        <img class="gallery-img package-transfer-img" *ngIf="riderOrderDetail.PickupPhotoImageUrl" src="{{riderOrderDetail.PickupPhotoImageUrl}}" (click)="showVisibleImageModal(OrderImageType.PickUp)" />
                        <img class="gallery-img package-transfer-img" *ngIf="riderOrderDetail.PickupSignatureImageUrl" src="{{riderOrderDetail.PickupSignatureImageUrl}}" (click)="showVisibleImageModal(OrderImageType.PickUp)" />
                        <div class="ml-4 mt-3">
                            <div class="package-transfer-title mb-3">Pick Up</div>
                            <div class="lm-left-block">Pickup Location:</div>
                            <div class="lm-left-block">Pickup Timestamp:</div>
                        </div>
                    </div>
                    <div class="ml-8" style="margin-top: 53px;">
                        <div class="lm-right-block">{{ riderOrderDetail.PointPickUpBuildingName || 'N/A' }}</div>
                        <div class="lm-right-block">{{ riderOrderDetail.PickedUpFormattedTime || 'N/A' }}</div>
                    </div>
                </div>

                <div class="lm-active-order-details-main-block flex">
                    <div class="flex">
                        <img class="gallery-img package-transfer-img" *ngIf="riderOrderDetail.DropPhotoImageUrl" src="{{riderOrderDetail.DropPhotoImageUrl}}" (click)="showVisibleImageModal(OrderImageType.DropOff)" />
                        <img class="gallery-img package-transfer-img" *ngIf="riderOrderDetail.DropSignatureImageUrl" src="{{riderOrderDetail.DropSignatureImageUrl}}" (click)="showVisibleImageModal(OrderImageType.DropOff)" />
                        <div class="ml-4 mt-3">
                            <div class="package-transfer-title mb-3">Drop Off</div>
                            <div class="lm-left-block">Drop Off Location:</div>
                            <div class="lm-left-block">Drop Off Timestamp:</div>
                        </div>
                    </div>
                    <div class="ml-8" style="margin-top: 53px;">
                        <div class="lm-right-block">{{ riderOrderDetail.PointDropOffBuildingName || 'N/A' }}</div>
                        <div class="lm-right-block">{{ riderOrderDetail.DropOffFormattedTime || 'N/A' }}</div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.CustomerProfile" class="mt-30">
                <div class="lm-active-order-details-main-block">
                    <div class="flex flex-row">
                        <div style="margin-right: 30px;" class="driver-info-img">
                            <img style="border: 2px solid #004060" *ngIf="riderOrderDetail.UserImageUrl; else placeholder"
                                 src="{{riderOrderDetail.UserImageUrl}}" />
                            <ng-template #placeholder>
                                <img style="border: 2px solid #004060" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                            </ng-template>
                        </div>
                        <div class="ml-3">
                            <div class="lm-active-order-details-field-block">
                                <div class="lm-active-order-details-field-name">Name:</div>
                                <div class="lm-active-order-details-field-value">
                                    <span class="lm-active-order-link"
                                          (click)="handleCustomerInfoClick(riderOrderDetail.UserId)">{{riderOrderDetail.UserFirstName}} {{riderOrderDetail.UserLastName | slice:0:1}}.</span>
                                </div>
                            </div>
                            <div class="lm-active-order-details-field-block">
                                <div class="lm-active-order-details-field-name">Sign up:</div>
                                <div class="lm-active-order-details-field-value">{{riderOrderDetail.UserCreatedAtText}} ({{riderOrderDetail.UserSignUpDaysPassed}} days)</div>
                            </div>
                            <div class="lm-active-order-details-field-block">
                                <div class="lm-active-order-details-field-name">Phone:</div>
                                <div class="lm-active-order-details-field-value">{{riderOrderDetail.UserPhoneMask}}&nbsp;</div>
                                <span class="lm-active-order-details-field-verification-status"
                                      [ngClass]="{'verified': isPhoneNumberVerified}">
                                    {{ riderOrderDetail.VerificationStatus }}
                                </span>
                            </div>
                            <div class="lm-active-order-details-field-block">
                                <div class="lm-active-order-details-field-name">Rating:</div>
                                <div class="lm-active-order-details-field-value">
                                    <span class="star-icon">&#9733;</span> {{riderOrderDetail.UserRatingFormatted}}
                                </div>
                            </div>
                            <div class="lm-active-order-details-field-block">
                                <div class="lm-active-order-details-field-name">Account:</div>
                                <div class="lm-active-order-details-field-value">
                                    <span class="lm-active-order-link">{{(riderOrderDetail.LoginProvider) ? riderOrderDetail.LoginProvider : 'Xpress'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="lm-active-order-details-main-block mt-3">
                    <ng-container *ngIf="!isCustomerStatisticsLoading; else customerStatisticsSkeleton">
                        <div class="lm-active-order-details-field-block">
                            <div class="lm-active-order-details-field-name">Bookings:</div>
                            <div class="lm-active-order-details-field-value">{{riderOrderDetail.BookingsCount}}</div>
                        </div>
                        <div class="lm-active-order-details-field-block">
                            <div class="lm-active-order-details-field-name">Completed:</div>
                            <div class="lm-active-order-details-field-value">{{riderOrderDetail.CompletedCount}} ({{riderOrderDetail.CompletedPercent}}%)</div>
                        </div>
                        <div class="lm-active-order-details-field-block">
                            <div class="lm-active-order-details-field-name">Spend:</div>
                            <div class="lm-active-order-details-field-value">{{riderOrderDetail.TotalSpendText}}</div>
                        </div>
                    </ng-container>
                    <div class="lm-active-order-details-field-block">
                        <div class="lm-active-order-details-field-name">Priority:</div>
                        <div class="lm-active-order-details-field-value"></div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.Payment" class="mt-30">
                <div>
                    <div class="flex flex-column">
                        <div class="transaction-info-title">Xpress Transaction</div>
                        <div class="flex flex-row flex-wrap" style="margin-bottom: 15px;">
                            <div class="col-6 p-0 w-50-percent">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Transaction date:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionDate}}</div>

                                    <div class="col-6 p-0 mb-2">Transaction type:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.OperationTypeText}}</div>
                                </div>
                            </div>
                            <div class="col-6 p-0 w-50-percent">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Transaction time:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionTime}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-column">
                        <div class="transaction-info-title">Payment</div>
                        <div class="flex flex-row flex-wrap" style="margin-bottom: 15px;">
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Payment method:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        {{(bookingTransactionDetails.PaymentMethodText) ? bookingTransactionDetails.PaymentMethodText : 'N/A'}}
                                    </div>
                                    <div class="col-6 p-0 mb-2">Transaction amount:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionAmountText}}</div>
                                </div>
                            </div>
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Partner TX ID:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        <span class="lm-active-order-link">{{bookingTransactionDetails.PartnerTXID}}</span>
                                    </div>
                                    <div class="col-6 p-0 mb-2">Transaction status:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        <span *ngIf="bookingTransactionDetails.Status === 'PAID'" class="transaction-color-green">Success</span>
                                        <span *ngIf="bookingTransactionDetails.Status !== 'PAID'">{{bookingTransactionDetails.Status}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-column">
                        <div class="transaction-info-title">Payment Processor:</div>
                        <div class="flex flex-row flex-wrap" style="margin-bottom: 15px;">
                            <div class="col-6 p-0">
                                <div class="flex flex-row flex-wrap">
                                    <div class="col-6 p-0 mb-2">Partner:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">Xendit</div>
                                    <div class="col-6 p-0 mb-2">TX time:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionTime}}</div>
                                    <div class="col-6 p-0 mb-2">Reference:</div>
                                    <span class="lm-active-order-link">{{bookingTransactionDetails.Id}}</span>
                                    <div class="col-6 p-0 mb-2">Transaction status:</div>
                                    <div class="col-6 p-0 mb-2 transaction-value">
                                        <span *ngIf="bookingTransactionDetails.Status === 'PAID'" class="transaction-color-green">Success</span>
                                        <span *ngIf="bookingTransactionDetails.Status !== 'PAID'">{{bookingTransactionDetails.Status}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="activeTab === menuTab.Timeline" class="mt-30">
                <div>
                    <div class="odt-title">
                        Order Timeline
                    </div>
                    <div class="odr-subtitle">
                        Order Processing
                    </div>
                    <div class="lm-active-order-details-field-block">
                        <div class="lm-active-order-details-field-name w-5">Time accepted:</div>
                        <div class="lm-active-order-details-field-value">
                            {{riderOrderDetail.OrderAcceptedTimeText}}
                        </div>
                    </div>
                    <div class="lm-active-order-details-field-block">
                        <div class="lm-active-order-details-field-name w-5">Time Arrival on Pick up point</div>
                        <div class="lm-active-order-details-field-value">
                            {{riderOrderDetail.PickupTimeText || '-'}}
                        </div>
                    </div>
                    <ng-container *ngIf="riderOrderDetail.DropoffOrderTimes.length > 0">
                        <div *ngFor="let item of riderOrderDetail.DropoffOrderTimes; let i = index" class="lm-active-order-details-field-block">
                            <div class="lm-active-order-details-field-name w-5">
                                Time of Drop off
                                <span *ngIf="riderOrderDetail.DropoffOrderTimes.length > 1">#{{i + 1}}</span>
                            </div>
                            <div class="lm-active-order-details-field-value">{{item.dropOffText}}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="riderOrderDetail.DropoffOrderTimes.length === 0">
                        <div class="lm-active-order-details-field-block">
                            <div class="lm-active-order-details-field-name w-5">Arrived at Destination:</div>
                            <div class="lm-active-order-details-field-value">{{riderOrderDetail.DroppedOffTimeText || '-'}}</div>
                        </div>
                    </ng-container>
                    <ng-container
                        *ngIf="riderOrderDetail.ScheduledAt && riderOrderDetail.StatusId === xpressDeliveryStatus.Canceled && riderOrderDetail.CanceledAt && riderOrderDetail.CancelRoleId === xpressUserRole.Admin">
                        <div class="lm-active-order-details-field-block">
                            <div class="lm-active-order-details-field-name w-5 text-red-500">Cancelled by Admin:</div>
                            <div class="lm-active-order-details-field-value">{{riderOrderDetail.CanceledAtFormattedTime}}</div>
                        </div>
                    </ng-container>
                    <br />
                    <hr class="lm-active-order-details-hr" />
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.Assigning" class="mt-30">
                <div class="summary-info-container assigning-text font-16">
                    <div class="w-18percent summary-info-item">
                        <div>Total Attempts:</div>
                        <div>{{totalAttempts}}</div>
                    </div>
                    <div class="w-20percent summary-info-item">
                        <div>Total Time:</div>
                        <div>{{totalTimeText}}</div>
                    </div>
                </div>
                <div style="margin-top: 12px;">
                    <p-accordion>
                        <p-accordionTab [(selected)]="round1Selected">
                            <ng-template pTemplate="header">
                                <span class="flex align-items-center gap-2 w-full assigning-text font-18">
                                    <span class="font-bold white-space-nowrap">First Round</span>
                                    <span class="font-bold white-space-nowrap float-right"><{{firstRadiusToSortRidersInM}}m</span>
                                </span>
                            </ng-template>
                            <ng-template pTemplate="body">
                                <div class="assigning-text font-18" *ngIf="!round1Riders.length">No riders</div>
                                <p-scroller [items]="round1Riders"
                                            [itemSize]="50"
                                            scrollHeight="50vh"
                                            styleClass="border-1 surface-border"
                                            [style]="{height: '50vh'}">
                                    <ng-template pTemplate="item" let-item let-options="options" style="border: 0;">
                                        <div class="flex align-items-center assigning-tab-item"
                                             [ngClass]="{ 'surface-ground': options.odd, 'blue-background': (currentRound === AssigningRoundEnum.First && options.index === currentRiderIndex),
                                                                                             'white-background ': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.First }">
                                            <div *ngIf="currentRound === AssigningRoundEnum.First && options.index >= currentRiderIndex; else disabledItem"
                                                 [ngClass]="{ 'h-70': (currentRound === AssigningRoundEnum.First && options.index === currentRiderIndex),
                                                                  'h-100': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.First }"
                                                 style="width: 100%;" class="flex align-items-center gap-2 w-full p-2">
                                                <p-avatar [image]="item.RiderImageUrl" size="large" shape="circle" />
                                                <div class="flex flex-column">
                                                    <span [ngClass]="{'rider-data-color': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.First }" class="font-bold white-space-nowrap font-16">{{ item.RiderName }}</span>
                                                    <span *ngIf="item.PairingReason" class="assigning-pairing-reason">{{ item.PairingReason }}</span>
                                                </div>
                                                <div [ngClass]="{'rider-data-color': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.First }" class="ml-auto assigning-tab-item-options">
                                                    <span>★ {{ item.RiderRate }}</span>
                                                    <span>•</span>
                                                    <span>{{ item.DistanceInM }} meters</span>
                                                    <span>•</span>
                                                    <span>{{ item.CountTrips }} Trips today</span>
                                                    <span>•</span>
                                                    <span>{{ item.AcceptanceRate }}%</span>
                                                </div>
                                            </div>
                                            <ng-template #disabledItem>
                                                <div [ngClass]="{ 'h-70': options.index === currentRiderIndex && currentRound !== AssigningRoundEnum.First, 'h-100': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.First }"
                                                     style="width: 100%;" class="flex align-items-center gap-2 w-full p-2">
                                                    <p-avatar [image]="item.RiderImageUrl" size="large" shape="circle" />
                                                    <div class="flex flex-column">
                                                        <span class="font-bold white-space-nowrap" style="opacity: 0.5;">{{ item.RiderName }}</span>
                                                        <span *ngIf="item.PairingReason" class="assigning-pairing-reason">{{ item.PairingReason }}</span>
                                                    </div>
                                                    <div class="ml-auto flex flex-row disabled-item-status-container">
                                                        <span class="disabled-item-status">
                                                            <div style="color: #333333;">
                                                                {{ item.RiderActionText }}
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <div *ngIf="currentRound === AssigningRoundEnum.First && options.index === currentRiderIndex && riderOrderDetail.StatusId === xpressDeliveryStatus.RiderAssigning" class="item-progress-line">
                                                <div class="progress-bar" [style.width.%]="progressValue * 5"></div>
                                                <div class="progress-value">{{ (progressValue | number:'1.0-0') }} secs</div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-scroller>
                            </ng-template>
                        </p-accordionTab>

                        <p-accordionTab [(selected)]="round2Selected">
                            <ng-template pTemplate="header">
                                <span class="flex align-items-center gap-2 w-full assigning-text font-18">
                                    <span class="font-bold white-space-nowrap">Second Round</span>
                                    <span class="font-bold white-space-nowrap float-right"><{{secondRadiusToSortRidersInM}}m</span>
                                </span>
                            </ng-template>
                            <ng-template pTemplate="body">
                                <div class="assigning-text font-18" *ngIf="!round2Riders.length">No riders</div>
                                <p-scroller [items]="round2Riders"
                                            [itemSize]="50"
                                            scrollHeight="50vh"
                                            styleClass="border-1 surface-border"
                                            [style]="{height: '50vh'}">
                                    <ng-template pTemplate="item" let-item let-options="options" style="border: 0;">
                                        <div class="flex align-items-center assigning-tab-item"
                                             [ngClass]="{ 'surface-ground': options.odd, 'blue-background': (currentRound === AssigningRoundEnum.Second && options.index === currentRiderIndex),
                                                                                             'white-background ': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Second}">
                                            <div *ngIf="currentRound <= AssigningRoundEnum.Second && item.RiderAction === OrderRiderActionEnum.Offer; else disabledItem"
                                                 [ngClass]="{ 'h-70': currentRound === AssigningRoundEnum.Second && options.index === currentRiderIndex,
                                                                 'h-100': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Second }"
                                                 style="width: 100%;" class="flex align-items-center gap-2 w-full p-2">
                                                <p-avatar [image]="item.RiderImageUrl" size="large" shape="circle" />
                                                <div class="flex flex-column">
                                                    <span [ngClass]="{'rider-data-color': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Second}" class="font-bold white-space-nowrap font-16">{{ item.RiderName }}</span>
                                                    <span *ngIf="item.PairingReason" class="assigning-pairing-reason">{{ item.PairingReason }}</span>
                                                </div>
                                                <div [ngClass]="{'rider-data-color': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Second }" class="ml-auto assigning-tab-item-options">
                                                    <span>★ {{ item.RiderRate }}</span>
                                                    <span>•</span>
                                                    <span>{{ item.DistanceInM }} meters</span>
                                                    <span>•</span>
                                                    <span>{{ item.CountTrips }} Trips today</span>
                                                    <span>•</span>
                                                    <span>{{ item.AcceptanceRate }}%</span>
                                                </div>
                                            </div>
                                            <ng-template #disabledItem>
                                                <div [ngClass]="{ 'h-70': options.index === currentRiderIndex && currentRound === AssigningRoundEnum.Second,
                                                                     'h-100': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Second }"
                                                     style="width: 100%;" class="flex align-items-center gap-2 w-full p-2">
                                                    <p-avatar [image]="item.RiderImageUrl" size="large" shape="circle" />
                                                    <div class="flex flex-column">
                                                        <span class="font-bold white-space-nowrap" style="opacity: 0.5;">{{ item.RiderName }}</span>
                                                        <span *ngIf="item.PairingReason" class="assigning-pairing-reason">{{ item.PairingReason }}</span>
                                                    </div>
                                                    <div class="ml-auto flex flex-row disabled-item-status-container">
                                                        <span class="disabled-item-status">
                                                            <div style="color: #333333;">
                                                                {{ item.RiderActionText }}
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <div *ngIf="currentRound === AssigningRoundEnum.Second && options.index === currentRiderIndex && riderOrderDetail.StatusId === xpressDeliveryStatus.RiderAssigning" class="item-progress-line">
                                                <div class="progress-bar" [style.width.%]="progressValue * 5"></div>
                                                <div class="progress-value">{{ (progressValue | number:'1.0-0') }} secs</div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-scroller>
                            </ng-template>
                        </p-accordionTab>

                        <p-accordionTab [(selected)]="round3Selected">
                            <ng-template pTemplate="header">
                                <span class="flex align-items-center gap-2 w-full assigning-text font-18">
                                    <span class="font-bold white-space-nowrap">Third Round</span>
                                    <span class="font-bold white-space-nowrap float-right"><{{thirdRadiusToSortRidersInM}}m</span>
                                </span>
                            </ng-template>
                            <ng-template pTemplate="body">
                                <div class="assigning-text font-18" *ngIf="!round3Riders.length">No riders</div>
                                <p-scroller [items]="round3Riders"
                                            [itemSize]="50"
                                            scrollHeight="50vh"
                                            styleClass="border-1 surface-border"
                                            [style]="{height: '50vh'}">
                                    <ng-template pTemplate="item" let-item let-options="options" style="border: 0;">
                                        <div class="flex align-items-center assigning-tab-item"
                                             [ngClass]="{ 'surface-ground': options.odd, 'blue-background': (options.index === currentRiderIndex && currentRound === AssigningRoundEnum.Third),
                                                                                             'white-background ': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Third}">
                                            <div *ngIf="currentRound <= AssigningRoundEnum.Third && item.RiderAction === OrderRiderActionEnum.Offer; else disabledItem"
                                                 [ngClass]="{ 'h-70': (options.index === currentRiderIndex && currentRound === AssigningRoundEnum.Third),
                                                                 'h-100': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Third }"
                                                 style="width: 100%;" class="flex align-items-center gap-2 w-full p-2">
                                                <p-avatar [image]="item.RiderImageUrl" size="large" shape="circle" />
                                                <div class="flex flex-column">
                                                    <span [ngClass]="{'rider-data-color': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Third }" class="font-bold white-space-nowrap font-16">{{ item.RiderName }}</span>
                                                    <span *ngIf="item.PairingReason" class="assigning-pairing-reason">{{ item.PairingReason }}</span>
                                                </div>
                                                <div [ngClass]="{'rider-data-color': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Third }" class="ml-auto assigning-tab-item-options">
                                                    <span>★ {{ item.RiderRate }}</span>
                                                    <span>•</span>
                                                    <span>{{ item.DistanceInM }} meters</span>
                                                    <span>•</span>
                                                    <span>{{ item.CountTrips }} Trips today</span>
                                                    <span>•</span>
                                                    <span>{{ item.AcceptanceRate }}%</span>
                                                </div>
                                            </div>
                                            <ng-template #disabledItem>
                                                <div [ngClass]="{ 'h-70': (options.index === currentRiderIndex && currentRound === AssigningRoundEnum.Third),
                                                                     'h-100': options.index !== currentRiderIndex || currentRound !== AssigningRoundEnum.Third }"
                                                     style="width: 100%;" class="flex align-items-center gap-2 w-full p-2">
                                                    <p-avatar [image]="item.RiderImageUrl" size="large" shape="circle" />
                                                    <div class="flex flex-column">
                                                        <span class="font-bold white-space-nowrap" style="opacity: 0.5;">{{ item.RiderName }}</span>
                                                        <span *ngIf="item.PairingReason" class="assigning-pairing-reason">{{ item.PairingReason }}</span>
                                                    </div>
                                                    <div class="ml-auto flex flex-row disabled-item-status-container">
                                                        <span class="disabled-item-status">
                                                            <div style="color: #333333;">
                                                                {{ item.RiderActionText }}
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <div *ngIf="currentRound === AssigningRoundEnum.Third && options.index === currentRiderIndex && riderOrderDetail.StatusId === xpressDeliveryStatus.RiderAssigning" class="item-progress-line">
                                                <div class="progress-bar" [style.width.%]="progressValue * 5"></div>
                                                <div class="progress-value">{{ (progressValue | number:'1.0-0') }} secs</div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-scroller>
                            </ng-template>
                        </p-accordionTab>

                    </p-accordion>
                </div>
            </div>
            <div *ngIf="activeTab === menuTab.Messages">
                <div class="order-detail-chat-title">
                    Driver and Customer Messages
                </div>

                <div *ngFor="let item of riderOrderDetail.OrderChats">
                    <div class="order-detail-block-message-rider" *ngIf="item.MessageTypeId === chatMessageType.RiderToCustomer">
                        <div class="w-70">
                            <div class="message-author">{{item.RiderFullName}}</div>
                            <div class="order-detail-chat-message-rider message-text-left">{{item.Message}}</div>
                            <div class="message-date flex justify-content-end">{{item.CreatedAt}}</div>
                        </div>
                    </div>
                    <div class="order-detail-block-message-passenger" *ngIf="item.MessageTypeId === chatMessageType.CustomerToRider">
                        <div class="w-70">
                            <div class="message-author flex justify-content-end">{{item.CustomerFullName}}</div>
                            <div class="order-detail-chat-message-passenger message-text-right">{{item.Message}}</div>
                            <div class="message-date ">{{item.CreatedAt}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #customerStatisticsSkeleton>
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Bookings:</div>
                    <div class="lm-active-order-details-field-value flex justify-content-end">
                        <p-skeleton width="3rem" height="1.25rem"></p-skeleton>
                    </div>
                </div>
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Completed:</div>
                    <div class="lm-active-order-details-field-value flex justify-content-end">
                        <p-skeleton width="5.5rem" height="1.25rem"></p-skeleton>
                    </div>
                </div>
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Spend:</div>
                    <div class="lm-active-order-details-field-value flex justify-content-end">
                        <p-skeleton width="4.5rem" height="1.25rem"></p-skeleton>
                    </div>
                </div>
            </ng-template>

        </div>
    </p-scrollPanel>

</p-sidebar>
